/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.19.0
 */

import dayjs from 'dayjs';

export const getTimeZone = (timestamp: number | string): string => {
    const utc = dayjs(timestamp).utcOffset() / 60;
    const timezone = utc < 10 ? `0${utc}` : utc
    return `(UTC+${timezone})`;
}
